export const pick = (value, language = 'da') => {
  if (typeof value === 'string') return value;
  if (!value || typeof value !== 'object') return '';
  return value[language] ?? Object.values(value).find((item) => typeof item === 'string') ?? '';
};

export const slugOf = (item) => pick(item?.slug);

export const cleanPath = (path) => {
  const value = String(path || '/').split(/[?#]/)[0].replace(/\/+$/, '');
  return value || '/';
};

// These are stable CMS entry IDs, not URLs. Editors can change each page's path independently.
export const PAGE = Object.freeze({
  home: 'side-forside',
  education: 'side-uddannelsen',
  treatments: 'side-behandlinger',
  grooming: 'side-hundefrisoer',
  osteopathy: 'side-hundeosteopati',
  massage: 'side-massage',
  craniosacral: 'side-kranio-sakral',
  prices: 'side-priser',
  about: 'side-om-salon-k9',
  booking: 'side-book-tid',
  talk: 'side-book-samtale',
  forbidden: 'side-403',
  notFound: 'side-404',
});

export const isExternalHref = (href) => /^(https?:\/\/|mailto:|tel:)/i.test(String(href || ''));
